export default __webpack_public_path__ + "static/media/bluespacedestactive2.73670535.png";